import { render, staticRenderFns } from "./DEXT5UploadForOog.vue?vue&type=template&id=d2dd9afa&scoped=true"
import script from "./DEXT5UploadForOog.vue?vue&type=script&lang=js"
export * from "./DEXT5UploadForOog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dd9afa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2dd9afa')) {
      api.createRecord('d2dd9afa', component.options)
    } else {
      api.reload('d2dd9afa', component.options)
    }
    module.hot.accept("./DEXT5UploadForOog.vue?vue&type=template&id=d2dd9afa&scoped=true", function () {
      api.rerender('d2dd9afa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DEXT5UploadForOog.vue"
export default component.exports